import React from 'react';
import './About.css';
import { Link } from 'react-router-dom';

const About = () =>{
  return (
  <div className="about-container">
    <div className="section">
      <div className='title'>About Me</div>
      <div className='para'>
        <p>
          Hello (again), I'm <strong>Pranit Singh Gandhi</strong>, an aspiring Software Engineer, an earnest Computer Science Student at New York University, and a former AI Intern at Ernst & Young. 
        </p>
      </div>
      <div className='arrow'>↓</div>
    </div>
    <div className="section experience">
      <div className='title'>Experience</div>
      <div className='cards'>
      <div className = 'card' id='nyu'>              
            <div className='picture'>
            <img src='./icons/hat2.png' alt="hat"></img>
            </div>
            <div className='card-text'>
              <div className='company'>
                New York University
              </div>
              <div className='role'>
                CS Teaching Assistant
              </div>
            </div>
          </div>

          <div className = 'card' id='ey'>              
            <div className='picture'>
            <img src='./icons/robot4.png' alt="robot"></img>
            </div>
            <div className='card-text'>
              <div className='company'>
                Ernst & Young
              </div>
              <div className='role'>
                Summer AI Intern
              </div>
            </div>
          </div>

          <div className='card' id='iasc'>
            <div className='picture'>
              <img src='./icons/planet2.png' alt="planet"></img>
            </div>
            <div className='card-text'>
              <div className='company'>
                IASC
              </div>
              <div className='role'>
                Citizen Scientist
              </div>
            </div>
          </div>

          <div className='card' id='solarity'>
            <div className='picture'>
            <img src='./icons/code.png' alt="code"></img>
            </div>
            <div className='card-text'>
              <div className='company'>
                Solarity       
              </div> 
              <div className='role'>
                Automation Engineer Intern
              </div>
            </div>
          </div>

          <div className='card' id='ind'>
            <div className='picture'>
            <img src='./icons/lotus.png' alt="lotus"></img>
            </div>
            <div className='card-text'>
              <div className='company'>
                Government of India
              </div>
              <div className='role'>
                Student Researcher
              </div>
            </div>
          </div>
      </div>
      <div className='arrow'>↓</div>

    </div>

    <div className="section">
      <div className='title'>Vision</div>
      <div className='para'>
        <p>
          My journey is fueled by a profound interest in Machine Learning, Deep Learning, and their use cases. 
        </p>
        <p>
          I consistently strive to leverage my skills and my experiences to contribute to solutions that address real-world challenges and drive technological advancements.
        </p>
        <p className='ending'>
          Thanks for viewing my portfolio. <Link to='/contact' className='connect'>Let's connect</Link> and build things together!
        </p>
      </div>
    </div>
  </div>
  )
}

export default About;
